// Translations
import form from '../sections/form/translations/ru'

// Translation: Login > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
